import type { MedicalTreatmentAppointment } from "@/lib/types";
import dayjs from "dayjs";

export function getTreatmentAppointmentStartsAt(
  appointment: Pick<MedicalTreatmentAppointment, "date" | "time">,
) {
  const date = dayjs(appointment.date.slice(0, 10)).startOf("day");
  return appointment.time
    ? dayjs(`${date.format("YYYY-MM-DD")}T${appointment.time}`)
    : date;
}
